import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

import { actionCreators } from '@/checkout-instore-legacy/vendor/actions'
import {
  vendorErrorSelector,
  vendorSamlProvidersSelector,
  vendorOAuthProvidersSelector,
} from '@/checkout-instore-legacy/vendor/selectors'

import LoginForm from './LoginForm'

const mapStateToPropsSelector = createStructuredSelector({
  error: vendorErrorSelector,
  samlProviders: vendorSamlProvidersSelector,
  oAuthProviders: vendorOAuthProvidersSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToPropsSelector, mapDispatchToProps)(LoginForm)
